import { httpApi } from '@api/http.api.ts';
import type { EVENT_SOURCES, EVENT_TYPES } from '@constants/eventTypes.ts';
import type { ProgressInfo } from '@routes/sidebar/learning/api/learning.api.ts';
import type { CommonSearchRequest, PaginatedResponse } from '@types';

export type NotificationType = (typeof EVENT_TYPES)[keyof typeof EVENT_TYPES];
export type NotificationSource = (typeof EVENT_SOURCES)[keyof typeof EVENT_SOURCES];

export interface NotificationDetails {
    id: number;
    notificationSource: NotificationSource;
    notificationType: NotificationType;
    dueDateUTC: string | null;
    createdUTC: string;
    pathwayId: number | null;
    elementId: number | null;
    hasOpenAction: boolean;
    topic: string;
    pathwayName: string | null;
    assesseeName: string | null;
    description: string | null;
    wasRead: boolean;
    wasSeen: boolean;
}

export const ProgressTimeLeft = (progressInfo: ProgressInfo): number => {
    if (progressInfo.progressPercent === 100) {
        return 0; //this will avoid situation where pathway was updated with totalTime > spendTimeInMinutes having time left on completed pathways
    }
    const timeLeft = progressInfo.totalTimeInMinutes - progressInfo.spendTimeInMinutes;
    return timeLeft < 0 ? 0 : timeLeft;
};

export type UserNotificationRequest = CommonSearchRequest;

export interface UserNotificationResultsDescription {
    totalNewNotifications: number;
    assignedNew: number;
    unreadNew: number;
}

export const getUserNotifications = (
    userNotificationRequest: UserNotificationRequest,
): Promise<PaginatedResponse<NotificationDetails, UserNotificationResultsDescription>> =>
    httpApi
        .post<
            PaginatedResponse<NotificationDetails, UserNotificationResultsDescription>
        >(`users/notifications/search`, { ...userNotificationRequest })
        .then(({ data }) => data);

export const putApiToggleNotificationRead = (id: number): Promise<any> =>
    httpApi.put<any>(`users/notifications/read-toggle/${id}`).then(({ data }) => data);

export const putApiMarkSeenNotification = (ids: number[]): Promise<any> =>
    httpApi.put<any>(`users/notifications/mark-seen`, ids).then(({ data }) => data);

export const putApiToggleReadAllNotifications = (wasRead: boolean): Promise<any> =>
    httpApi.put<any>(`users/notifications/set-read-all?setWasRead=${wasRead}`).then(({ data }) => data);
